var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen.lock",
          value: _vm.fullscreenLoading,
          expression: "fullscreenLoading",
          modifiers: { fullscreen: true, lock: true }
        }
      ],
      staticClass: "verify-box",
      staticStyle: { width: "500px" }
    },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "补发寄出",
            visible: true,
            "before-close": _vm.onCloseDialog,
            width: "400px"
          }
        },
        [
          _c(
            "el-form",
            [
              _c(
                "el-select",
                {
                  attrs: { size: "mini", placeholder: "快递公司" },
                  model: {
                    value: _vm.shipping_name,
                    callback: function($$v) {
                      _vm.shipping_name = $$v
                    },
                    expression: "shipping_name"
                  }
                },
                _vm._l(_vm.shipping_company, function(item) {
                  return _c("el-option", {
                    key: item.shipping_name,
                    attrs: {
                      label: item.shipping_company,
                      value: item.shipping_name
                    }
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "快递单号：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: { size: "small", placeholder: "" },
                    model: {
                      value: _vm.shipping_num,
                      callback: function($$v) {
                        _vm.shipping_num = $$v
                      },
                      expression: "shipping_num"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.submitData }
                    },
                    [_vm._v("提交")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b90ba0aa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b90ba0aa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/work/components/SendBf.vue
// module id = null
// module chunks = 